import { List, Record } from 'immutable'

export const Videos = Record({
  items: List(),
  pending: false,
  loaded: false,
  // current page will increase to 1 on the first load
  currentPage: 0,
})

export const Thumbnail = Record({
  height: null,
  width: null,
  url: null,
})

export const Video = Record({
  hashed_id: null,
  name: null,
  thumbnail: new Thumbnail(),
})
